import {
  BooleanInput,
  DateInput,
  SimpleForm,
  SimpleFormProps,
  TextInput,
  required
} from 'react-admin';
import { UploadImageInput } from '../../components';
import { dateFormatter } from '../../utils'

const now = Date.now();

export default function OffersForm(props: Partial<SimpleFormProps>) {
  return (
    <SimpleForm {...props} redirect="list">
      <TextInput
        autoComplete="off"
        fullWidth
        label="Título"
        source="title"
        validate={[required()]}
      />

      <TextInput
        autoComplete="off"
        fullWidth
        label="Descrição"
        source="description"
        validate={[required()]}
      />

      <UploadImageInput
        fullWidth
        helperText="É possível enviar imagens no formato JPEG com dimensões recomendadas de ?x?px."
        label="Foto"
        upploadOptions={{
          maxSize: [168, 288]
        }}
        mimeTypes={['image/jpeg']}
        source="photo"
        validate={[required()]}
      />

      <TextInput
        autoComplete="off"
        fullWidth
        label="Link"
        source="link"
        validate={[required()]}
      />

      <DateInput
        autoComplete="off"
        defaultValue={now}
        format={dateFormatter}
        fullWidth
        label="Inicia em"
        source="startsAt"
        validate={[required()]}
      />

      <DateInput
        autoComplete="off"
        defaultValue={now}
        format={dateFormatter}
        fullWidth
        label="Finaliza em"
        source="endsAt"
        validate={[required()]}
      />

      <BooleanInput label="Ativo" source="active" defaultValue />
    </SimpleForm>
  );
}
